<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:33:18
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 01:39:17
-->
<template>
  <div class="accountant-business">
    <Header3 key="header2" menuName="dispatchOrder" :keyWord.sync="keyWord" pageName="维修" :component.sync="component"></Header3>
    <Footer :page="1"></Footer>
    <!-- <components :is=""></components> -->
    <dispatchReciveOrder :keyWord.sync="keyWord" v-if="component==='dispatchReciveOrder'" class="dispatchReciveOrder component"></dispatchReciveOrder>
    <dispatchUnreciveOrder :keyWord.sync="keyWord"  v-if="component==='dispatchUnreciveOrder'" class="dispatchUnreciveOrder component"></dispatchUnreciveOrder>
  </div>
</template>

<script>
import Footer from "@/components/Footer"
import Header3 from "@/components/Header3"
import dispatchReciveOrder from "./components/dispatchReciveOrder"
import dispatchUnreciveOrder from "./components/dispatchUnreciveOrder"
export default {
  name: 'dispatchOrder',
  components: {
    Footer, Header3, dispatchReciveOrder ,dispatchUnreciveOrder
  },
  props: {

  },
  data () {
    return {
      keyWord: '',
      component: '',
    };
  },
  computed: {

  },
  watch: {
  },
  created () {

  },
  mounted () {
  },
  methods: {

  },
};
</script>

<style lang="less" scoped>
.accountant-business {
  padding-top: 150px;
  padding-bottom: 70px;
}
</style>
